var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CpslButton } from '@usecapsule/react-components';
import { StepContainer, InnerStepContainer } from '../common.js';
import { useCapsuleStore, useModalStore } from '../../stores/index.js';
import { ModalStep } from '../../utils/steps.js';
import { WalletCard, WalletCards } from '../WalletCard/WalletCard.js';
import styled from 'styled-components';
export const WalletCreationDoneStep = ({ twoFactorAuthEnabled, onClose }) => {
    const setStep = useModalStore(state => state.setStep);
    const isLogin = useModalStore(state => state.isLogin());
    const onRampConfig = useModalStore(state => state.onRampConfig);
    const capsule = useCapsuleStore(state => state.capsule);
    const isOnRampConfigured = (onRampConfig === null || onRampConfig === void 0 ? void 0 : onRampConfig.isBuyEnabled) || (onRampConfig === null || onRampConfig === void 0 ? void 0 : onRampConfig.isReceiveEnabled) || (onRampConfig === null || onRampConfig === void 0 ? void 0 : onRampConfig.isWithdrawEnabled);
    const handleNext = () => __awaiter(void 0, void 0, void 0, function* () {
        if (isLogin) {
            if (!twoFactorAuthEnabled) {
                setStep(ModalStep.LOGIN_DONE);
                return;
            }
            const is2FAComplete = yield capsule.check2FAStatus();
            setStep(is2FAComplete ? ModalStep.LOGIN_DONE : ModalStep.SETUP_2FA);
        }
        else {
            if (twoFactorAuthEnabled) {
                setStep(ModalStep.SETUP_2FA);
            }
            else {
                onClose();
            }
        }
    });
    return (_jsxs(StepContainer, { "$wide": true, children: [_jsx(CardContainer, { children: _jsx(WalletCards, { children: capsule.currentWalletIdsArray.map(([id, type]) => {
                        return _jsx(WalletCard, { id: id, type: type, showAddFunds: isOnRampConfigured }, id);
                    }) }) }), _jsx(InnerStepContainer, { children: _jsx(CpslButton, { fullWidth: true, onClick: handleNext, children: twoFactorAuthEnabled ? 'Continue' : 'Done' }) })] }));
};
const CardContainer = styled(InnerStepContainer) `
  min-height: 196px;
  justify-content: center;
`;
